export const getOperatorsUrl = () => '/business/operators';

export const getOperatorUrl = (id: string = ':id') => `/business/operators/${id}`;
